module.exports = __webpack_public_path__ + "static/media/bobber.fe758b8c.jpg";